import React from 'react';
import { AlertCircle } from 'lucide-react';

const UnsavedChangesIndicator = ({ hasUnsavedChanges, onSave, roadmapName = '', isCurrentlySaving = false }) => {
  // Removido o hook useSaveWithLogin - será gerenciado pelo App.js
  if (!hasUnsavedChanges) return null;
  
  return (
    <div className="fixed top-20 right-4 bg-gradient-to-r from-yellow-500 to-orange-500 text-white text-sm font-semibold px-5 py-3 rounded-xl shadow-lg z-[100] flex items-center gap-3 animate-slide-in-right backdrop-blur-sm">
      <AlertCircle className="w-4 h-4 animate-pulse" />
      <span className="flex-1">Alterações não salvas</span>
      <button
        onClick={onSave}
        disabled={isCurrentlySaving}
        className="px-3 py-1.5 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg text-xs font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1.5"
      >
        {isCurrentlySaving ? (
          <>
            <div className="w-3 h-3 border border-white border-t-transparent rounded-full animate-spin"></div>
            Salvando...
          </>
        ) : (
          <>
            <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            Salvar
          </>
        )}
      </button>
    </div>
  );
};

export default UnsavedChangesIndicator;
